import {
    Form,
    Select,
    Input,
    Button,
    InputNumber,
    Tooltip,
    notification,
    Icon,
} from 'antd';

const { TextArea } = Input;

const generateOptions = (options) => {
    if (!options) {
        return;
    }
    let arrayOptions = [];
    options.forEach(option => {
        arrayOptions.push(<Option key={option.key}>{option.value}</Option>);
    })
    return arrayOptions;
}


import React from 'react';
import { addNewPassword } from '../../api/password';
import { allowProtectionType } from '../../utils';

const { Option } = Select;

class PForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            disableds: {},
            protectionTypeOptions: [],
            postSelects: {},
            redirectToReferrer: false,
            isLoading: false,
            roles: ppwMasterPasswords.roles.map(value => ({ value, key: value })),
            postTypes: ppwMasterPasswords.postTypes,
            groups: [],
        }
    }

    handleAddAction = (values) => {
        const { closeModal, form } = this.props;
        const roleType = values['role-type'];
        const label = values['label'];
        const postTypes = values['post-types'].join(';');
        const protectionTypes = values['protection-types'] ? values['protection-types'].join(';'): null;
        let roleSelecteds = '';
        if (roleType === 'roles') {
            roleSelecteds = values['role-selecteds'].map((value) => `master_role_${value}`).join(';');
        }

        this.setState({ isLoading: true });
        addNewPassword({
            password: values['password'].split('\n').map(pass => pass.trim()).filter(pass => pass !== ""),
            expired_dates: values['expired-dates'],
            usage_limit: values['usage-limit'],
            role_type: roleType,
            roles_selected: roleSelecteds,
            label,
            post_types: postTypes,
            protection_types: protectionTypes
        }).then(() => {
            form.resetFields();
            notification['success']({
                message: 'PPWP Lite',
                description: 'Great! You’ve successfully created a new secure password.',
            });
            closeModal();
        }).catch(() => {
            notification['error']({
                message: 'PPWP Lite',
                description: 'You can\'t create a duplicate password. Please try again.',
            })
        }).finally(() => {
            this.setState({ isLoading: false });
        })
    }

    handleUpdateAction = (values) => {

    }

    hasChangeRole = (value) => {
        // console.log(`selected ${value}`);
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                console.log(err);
                return;
            }

            return this.handleAddAction(values);
        });
    };

    normFile = e => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    render() {
        const redirectToReferrer = this.state.redirectToReferrer;
        const { levels, form } = this.props;
        const { getFieldDecorator, getFieldValue } = form;

        const { isLoading } = this.state;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 },
            },
        };
        return (
            <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                <Form.Item label="New Password" colon={false}>
                    {getFieldDecorator('password', {
                        initialValue: this.props.password || '',
                        rules: [
                            {
                                required: true,
                                message: 'Please enter a password.'
                            },
                            {
                                validator(rule, value) {
                                    const passwords = value.replace(/\r\n/g,"\n").split("\n").filter(password => password);

                                    const isMaxlength = passwords.some((password) => password.length > 100);
                                    if ( isMaxlength ) {
                                        return Promise.reject('Use 100 characters or fewer for your password');
                                    }

                                    const isContainSpace = passwords.some(password => password.includes(' '));
                                    if (isContainSpace) {
                                        return Promise.reject('Please remove space in password');
                                    }

                                    if ( passwords.length !== new Set(passwords).size ) {
                                        return Promise.reject('Please remove the duplicated passwords');
                                    }
                                    return Promise.resolve();
                                },
                            }
                        ]
                    })(<TextArea rows="5" style={{ width: '90%' }} />)}
                </Form.Item>

                <Form.Item
                    label={
                        <span>
                            Label&nbsp;
                        </span>
                    }
                    colon={false}>
                    {
                        getFieldDecorator('label', {
                            initialValue: '',
                            rules: [
	                            {
		                            max: 255,
		                            message: 'Use 255 characters or fewer for your label.'
	                            },
                            ]
                        })(
	                        <Input style={{width: '90%'}}/>
                        )}
                </Form.Item>

                { allowProtectionType() && (
                     <Form.Item
                     label={
                         <span>
                                 Protection Types&nbsp;
                             <Tooltip title="Select the protection types this master password will apply on">
                                     <Icon type="question-circle-o"/>
                                 </Tooltip>
                             </span>
                     }
                     colon={false}>
                     {
                         getFieldDecorator('protection-types', {
                             rules: [{required: true, message: 'Please select protection type.'}],
                         })(
                             <Select placeholder="Select protection types" mode="multiple" style={{width: '90%'}}>
                                 {generateOptions(ppwMasterPasswords.protectionTypes)}
                             </Select>,
                         )
                     }
                 </Form.Item>
                )}

	            <Form.Item
		            label={
			            <span>
	                            Post Types&nbsp;
				            <Tooltip title="Select the post types this master password will apply on">
	                                <Icon type="question-circle-o"/>
	                            </Tooltip>
	                        </span>
		            }
		            colon={false}>
		            {
			            getFieldDecorator('post-types', {
				            rules: [{required: true, message: 'Please select a post type.'}],
			            })(
				            <Select placeholder="Select post types" mode="multiple" style={{width: '90%'}}>
					            {generateOptions(this.state.postTypes)}
				            </Select>,
			            )
		            }
	            </Form.Item>

                <Form.Item
                    label={
                        <span>
                            Type&nbsp;
                            <Tooltip title="Apply this password for everyone or specific roles only">
                                <Icon type="question-circle-o" />
                            </Tooltip>
                        </span>
                    }
                    colon={false}
                >
                    {getFieldDecorator('role-type', {
                        initialValue: "global",
                        rules: [
                            {
                                required: true,
                                message: 'Please select a role type.'
                            }
                        ],
                    })(
                        <Select placeholder="Select a password type" style={{ width: '90%' }}>
                            <Option value="global">Global</Option>
                            <Option value="roles">Roles</Option>
                        </Select>,
                    )}
                </Form.Item>
                {getFieldValue('role-type') === 'roles' &&
                    (
                        <Form.Item label=" " colon={false}>
                            {
                                getFieldDecorator('role-selecteds', {
                                    rules: [{ required: true, message: 'Please select a user role.' }],
                                })(
                                    <Select placeholder="Select user roles" mode="multiple" style={{ width: '90%' }}>
                                        {generateOptions(this.state.roles)}
                                    </Select>,
                                )
                            }
                        </Form.Item>
                    )
                }

                < Form.Item
                    colon={false}
                    label={
                        <span>
                            Usage Limit&nbsp;
	                        <Tooltip title="Enter a number or leave blank for unlimited password usage">
                                <Icon type="question-circle-o"/>
                            </Tooltip>
                        </span>
                    }
                >
                    {getFieldDecorator('usage-limit', { initialValue: undefined })(<InputNumber style={{ width: '90%' }} min={1} />)}
                </Form.Item>
                <Form.Item
                    label={
                        <span>
                            Password Expiry&nbsp;
	                        <Tooltip
		                        title="Enter the number of days before this password expires, or leave blank for no expiry">
                                <Icon type="question-circle-o"/>
                            </Tooltip>
                        </span>
                    }
                    colon={false}>
                    {getFieldDecorator('expired-dates', { initialValue: undefined })(<InputNumber style={{ width: '90%' }} min={1} />)}
                </Form.Item>
                <Form.Item wrapperCol={{ span: 12, offset: 4 }}>
                    <Button id="ppw-master-password-submit" type="primary" htmlType="submit" loading={isLoading}>
                        Add New
                     </Button>
                </Form.Item>
            </Form >
        );
    }
}

const PasswordForm = Form.create({ name: 'validate_other' })(PForm);

export default PasswordForm;



// WEBPACK FOOTER //
// ./components/PasswordForm/index.js